/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/semi */

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, MenuController, NavController, Platform } from '@ionic/angular';
import { DataService } from '../data.service';
import { Base } from '../models/base';

@Component({
  selector: 'app-hoots-menu',
  templateUrl: './hoots-menu.component.html',
  styleUrls: ['./hoots-menu.component.scss'],
})
export class HootsMenuComponent extends Base implements OnInit {

  page: string = "help"

  // eslint-disable-next-line max-len
  constructor(public alertController: AlertController, public menu:MenuController, public platform: Platform, public dataService: DataService, public router: Router, public navController: NavController) {
    super(platform, dataService, router, navController, alertController, menu)
  }

  ngOnInit() {
    //Base.console('info',this.router.url)
    this.page = this.router.url
  }

}
